import { useQuery } from "react-query";
import { searchContent } from "@/api";

export const useSearch = (payload: {
  query: string;
  tags_by_category?: string[][];
  min_duration?: number;
  max_duration?: number;
}) => {
  const numberOfTags = Object.values(payload.tags_by_category ?? []).reduce(
    (acc, curr) => acc + curr.length,
    0,
  );

  return useQuery(
    [
      "search",
      payload.query,
      payload.tags_by_category,
      payload.max_duration,
      payload.min_duration,
    ],
    () => {
      return searchContent(payload);
    },
    {
      enabled:
        (!!payload.query && payload.query.length >= 3) || numberOfTags > 0,
    },
  );
};
